// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"style_clearfix__2V0-r","text":"style_text__V4i5l","d-none":"style_d-none__3T1HU"};